/* PANDORINA — Buy 2 Get 1 Free progress nudge (cart drawer + cart page). */
(function () {
  var SET = 3;                       // buy 2 + 1 free
  var TYPES = ['charm', 'clip', 'spacer'];
  var OFFER_URL = '/collections/buy-2-get-1-free';
  var CSS_ID = 'pd-b2g1-css';

  function css() {
    if (document.getElementById(CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    s.textContent =
      '.pd-b2g1{display:block;margin:0;padding:11px 16px;background:#F7F7F5;border-bottom:1px solid #E8E8EB;' +
      'font-size:12.5px;line-height:1.45;color:#121217;text-decoration:none}' +
      '.pd-b2g1 b{font-weight:600}' +
      '.pd-b2g1--done{background:#121217;color:#fff;border-bottom-color:#121217}' +
      '.pd-b2g1__bar{display:block;height:3px;margin-top:8px;background:#E8E8EB;border-radius:2px;overflow:hidden}' +
      '.pd-b2g1--done .pd-b2g1__bar{background:rgba(255,255,255,.25)}' +
      '.pd-b2g1__fill{display:block;height:100%;background:#8A1E2C;transition:width .3s ease}' +
      '.pd-b2g1--done .pd-b2g1__fill{background:#fff}';
    document.head.appendChild(s);
  }

  function eligibleUnits(cart) {
    return (cart.items || []).reduce(function (n, it) {
      var t = (it.product_type || '').toLowerCase();
      var hit = TYPES.some(function (k) { return t.indexOf(k) > -1; });
      return hit ? n + it.quantity : n;
    }, 0);
  }

  function copy(units) {
    if (units === 0) return null;
    var free = Math.floor(units / SET);
    var need = (SET - (units % SET)) % SET;
    var pct = need === 0 ? 100 : Math.round(((units % SET) / SET) * 100);
    if (need === 0) {
      return {
        done: true,
        pct: 100,
        html: free === 1
          ? '<b>Your cheapest charm is free.</b> Add 3 more to unlock another one.'
          : '<b>' + free + ' charms are free in this cart.</b> Add 3 more to unlock another one.'
      };
    }
    return {
      done: false,
      pct: pct,
      html: 'Add <b>' + need + ' more charm' + (need > 1 ? 's' : '') + '</b> and the cheapest one is <b>free</b>.'
    };
  }

  function render(cart) {
    css();
    var data = copy(eligibleUnits(cart));
    var hosts = [];
    var drawer = document.querySelector('#t4s-mini_cart .t4s-drawer__header');
    if (drawer) hosts.push(drawer);
     var page = Array.prototype.find.call(document.querySelectorAll('#t4s-cart-page, .t4s-cart-page, form[action="/cart"]'), function (el) { return !el.closest('#t4s-mini_cart'); });
    if (page) hosts.push(page.firstElementChild ? page : null);

    document.querySelectorAll('.pd-b2g1').forEach(function (n) { n.remove(); });
    if (!data) return;

    hosts.filter(Boolean).forEach(function (host) {
      var a = document.createElement('a');
      a.className = 'pd-b2g1' + (data.done ? ' pd-b2g1--done' : '');
      a.href = OFFER_URL;
      a.innerHTML = data.html +
        '<span class="pd-b2g1__bar"><span class="pd-b2g1__fill" style="width:' + data.pct + '%"></span></span>';
      if (host.classList.contains('t4s-drawer__header')) host.insertAdjacentElement('afterend', a);
      else host.insertAdjacentElement('afterbegin', a);
    });
  }

  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 120);
  }

  // re-run whenever the cart is touched
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart') > -1 && url.indexOf('/cart.js') === -1) refresh();
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && u.indexOf('/cart') > -1 && u.indexOf('/cart.js') === -1) {
      this.addEventListener('load', refresh);
    }
    return _open.apply(this, arguments);
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer], [href="/cart"], [data-action="add-to-cart"], .t4s-product-form__submit')) refresh();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
